import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OrganisationMember } from '../../Models/Models/Customer/OrganisationMember';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientAccessesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(organisationMembers: Array<OrganisationMember>, accountHierarchyId: string): Promise<Array<OrganisationMember>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ClientAccesses/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisationMembers: organisationMembers, accountHierarchyId: accountHierarchyId }

    return AjaxWrapper.put<Array<OrganisationMember>, any>(url, data);
  }
}

